import z from "zod";

// TODO: Add actual error types for Localization backend logic
const localizationErrorTypeValues = ["PLACEHOLDER_ERROR"] as const;

const localizationErrorTypeSchema = z.enum(localizationErrorTypeValues);
const LocalizationErrorType = localizationErrorTypeSchema.enum;
type LocalizationErrorType = z.infer<typeof localizationErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type LocalizationErrors = {
  errorType: typeof LocalizationErrorType.PLACEHOLDER_ERROR;
  // TODO: Add specific data fields for Localization errors
  data: Record<string, never>;
};

export const localizationErrorDetails: Record<LocalizationErrorType, ErrorDetails> = {
  [LocalizationErrorType.PLACEHOLDER_ERROR]: {
    sentryDescription: "Localization backend logic error",
  },
};
